type EventName = 'open-back-in-stock-notification-dialog';

export const Name: EventName = 'open-back-in-stock-notification-dialog';
export const ToggleFavorite: EventName = Name;

export interface Data {
  code: string;
}

export interface Event extends CustomEvent<Data> {
  type: EventName;
}

export default Event;
